export const SET_SEARCH_QUERY = 'web-gallery/SET_SEARCH_QUERY';
export const RESET_SEARCH_QUERY = 'web-gallery/RESET_SEARCH_QUERY';

export const setSearchQuery = query => ({
  type: SET_SEARCH_QUERY,
  query,
});

export const resetSearchQuery = () => ({
  type: RESET_SEARCH_QUERY,
});
